module.exports = __webpack_public_path__ + "img/Our_Inn_Place@2x.6ec33c5a.webp";